export default __webpack_public_path__ + "static/media/kids.a94d0170.JPG";